import { render, staticRenderFns } from "./examBegin.vue?vue&type=template&id=7917fec0&scoped=true"
import script from "./examBegin.vue?vue&type=script&lang=js"
export * from "./examBegin.vue?vue&type=script&lang=js"
import style0 from "./examBegin.vue?vue&type=style&index=0&id=7917fec0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7917fec0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7917fec0')) {
      api.createRecord('7917fec0', component.options)
    } else {
      api.reload('7917fec0', component.options)
    }
    module.hot.accept("./examBegin.vue?vue&type=template&id=7917fec0&scoped=true", function () {
      api.rerender('7917fec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/courseTrain/meredu/components/examBegin.vue"
export default component.exports